module.exports = __webpack_public_path__ + "static/media/infiniti-light.4a0f62a2.ttf";